import React, { useState } from 'react';

const Blog = () => {
   

    return (
        <div>
            <h1 className='text-white text-center text-3xl font-semibold my-10'>
                <span className='p-1 border-b-2 border-primary'>Our <span className='text-primary'>Blogs</span></span>
            </h1>
         
        </div >
    );
};

export default Blog;